<div class="rounded-xl bg-white">
  <div class="rounded-xl bg-white p-4">
    <h2 class="text-lg font-semibold mb-4">Notifications</h2>
    <h4 *ngIf="helpText">{{helpText}}</h4>
    <div class="max-h-[400px] overflow-auto">
      <table
        mat-table
        [dataSource]="notificationStore?.notifications?.items"
        class="mat-elevation-z1 w-full"

      >
        <!-- ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Test ID</th>
          <td mat-cell *matCellDef="let element">
            <a class="cursor-pointer text-primary" (click)="onTestClick(element)" >
              {{ element.id }}</a>

            <td>
        </ng-container>

            <!-- Date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let element">
            {{ element.startTime | formatTodayOrDate}}
          </td>
        </ng-container>

        <!-- Patient Name Column -->
        <ng-container matColumnDef="patientName">
          <th mat-header-cell *matHeaderCellDef>Patient Name</th>
          <td mat-cell *matCellDef="let element">
            {{ element.patient?.user?.firstName }}
            {{ element.patient?.user?.lastName }}
          </td>
        </ng-container>



        <tr mat-header-row *matHeaderRowDef=" ['id', 'date', 'patientName']"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['id', 'date', 'patientName']"
        ></tr>

      </table>
        </div>

    <div
      *ngIf="!notificationStore?.isLoading && !notificationStore?.notifications?.items?.length"
      class="text-gray-500 mt-4"
    >
      No notifications available.
    </div>
    <div class="flex items-center justify-center flex-1">
           <mat-spinner *ngIf="notificationStore?.isLoading"   [diameter]="20"></mat-spinner>
    </div>


  </div>
</div>
